"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var AutomationsFilled = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M16.4999652,4 L10.5,4 C10.2915777,4 10.1050174,4.12928642 10.0318354,4.32443828 L7.03193585,12.3241704 C6.93497579,12.5827306 7.08395386,12.999 7.500286,12.9997321 L9.473,12.999 L7.02563344,20.3419197 C6.87790374,20.7844594 7.44189474,21.2377989 7.83446276,20.8716647 L17.8348264,11.8713375 C18.1450348,11.6116638 17.9801941,10.999 17.5004629,10.9996904 L14.596,10.999 L16.9681093,4.67561627 C17.0650995,4.41706741 16.910553,4 16.4999652,4 Z" })));
};
AutomationsFilled.displayName = 'AutomationsFilled';
exports.default = AutomationsFilled;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=AutomationsFilled.js.map